import axios from '../helpers/Axios'

export default {

  async search(search) {
    return await axios.post("/search", search, {timeout: 1000 * 300});
  },

  async unbookedSearch(search) {
    return await axios.post("/search/unbooked", search, {timeout: 1000 * 120});
  },

}
